import { Navigate, useParams } from 'react-router-dom'

import { AppLayout } from '../components/AppLayout'
import { useDocumentTitle } from '../seo/useDocumentTitle'
import { DEMO_PROJECT_ID } from './demo'

/**
 * DemoGuard lets a signed-out visitor into the demo project and nothing else.
 *
 * The demo is mounted on `/projects/:projectId` rather than on a path of its
 * own so that `projectId` is a real route parameter. Every page and every link
 * in the app is built from that parameter; a static `/projects/demo` route
 * leaves it undefined and the whole subtree renders as an empty project — which
 * is exactly what it did before this existed.
 */
export function DemoGuard() {
  const { projectId } = useParams<{ projectId: string }>()

  useDocumentTitle(
    'Live demo — a Go service profiled | PecGoProf',
    'A real Go service profiled: flame graphs, top functions and a deploy that made JSON encoding three times more expensive. Sample data, no account needed.',
  )

  if (projectId !== DEMO_PROJECT_ID) {
    return <Navigate to="/" replace />
  }
  return <AppLayout />
}
